module.exports = __webpack_public_path__ + "files/61224cba8a7238881ecaeca7b38f3fe3.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/ubuntu-bold-webfont.ttf
// module id = 934
// module chunks = 60